// export const baseURL = 'https://ekun.corporate.kekere.com/api';
export const baseURL = 'https://api.corporate.kekere.com/api';


// export const StorageBaseURL = 'https://ekun.corporate.kekere.com';
export const StorageBaseURL = 'https://api.corporate.kekere.com';
